import { makeStyles } from "components/providers/makeStyles";

export const useNavStyles = makeStyles(theme => ({
    container: {
        maxWidth: "100vw",
        paddingBottom: theme.spacing(5)
    },
    nav: {
        display: "flex",
        overflowX: "auto",
        marginBottom: theme.spacing(2),
        WebkitOverflowScrolling: "touch",
        "&&::-webkit-scrollbar": {
            display: "none"
        }
    },
    addRound: {
        "&&": {
            alignSelf: "center"
        }
    }
}));
